module.exports = __webpack_public_path__ + "static/BG (1)-863e5cd3e14b96cd5a41d2414e2ec8a5.png";